import React from 'react';
import { Input, Button, TitleModalRight, Textarea, PaperClip } from 'components';
import { ServiceService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { PriceIcon, CloseIcon } from 'assets/icons';
import moment from 'moment';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface Props {
	onClose?: any;
	item?: any;
	title?: string;
	journeys?: any;
	types?: any;
}

class CreateService extends React.Component<Props> {

	state = {
		form: {
			name: '',
			description: '',
			photo: '',
			secondary_photo: '',
			type_id: Constants.SERVICE_TYPES.CLEAN,
			price: '',
			price_corporate: '',
			include_marquee: Constants.INCLUDE_MARQUEE.NO,
			banner: '',
			recommendation: '',
			tasks: '',
			order: '',
		},
		service_includes: [],
		service_areas: [],
		areas: [{
			area: '',
			price: '',
			price_corporate: ''
		}],
		journeys: this.props.journeys ? Globals.clone(this.props.journeys) : []
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name || '',
					description: this.props.item?.description || '',
			        photo: this.props.item?.photo || '',
			        secondary_photo: this.props.item?.secondary_photo || '',
			        type_id: this.props.item?.type_id || '',
			        price: this.props.item?.price || '',
			        price_corporate: this.props.item?.price_corporate || '',
			        include_marquee: this.props.item?.include_marquee || Constants.INCLUDE_MARQUEE.NO,
			        recommendation: this.props.item?.recommendation || '',
			        tasks: this.props.item?.tasks || '',
					order: this.props.item?.order || '',
				},
				journeys: this.state.journeys.map((i: any) => {
					i.quantity = 0;

					const service_journey = this.props.item?.service_journeys?.find((item: any) => item.journey_id == i.id);
					if (service_journey) {
						i.quantity = service_journey.quantity;
					}

					return i;
				}),
				service_includes: this.props.item?.service_includes?.map((i: any) => {
					return {
						name: i.name,
						quantity: i.quantity
					}
				}) || [],
				service_areas: this.props.item?.service_areas?.map((i: any) => {
					return {
						name: i.name,
						price: i.price,
						type_id: i.type_id,
						limit: i.limit
					}
				}) || []
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (this.props.item != null) {
			await ServiceService.admin.update({
				service_id: this.props.item?.id,
				...this.state.form,
				hasFile: true,
				// @ts-ignore,
				photo: this.state.form.photo?.value || '',
				// @ts-ignore,
				banner: this.state.form.banner?.value || '',
				// @ts-ignore,
				secondary_photo: this.state.form.secondary_photo?.value || '',
				journeys: JSON.stringify(this.state.journeys.map((i: any) => {
					return {
						journey_id: i.id,
						quantity: i.quantity
					}
				})),
				service_includes: JSON.stringify(this.state.service_includes?.filter((i: any) => i.name != '').map((i: any) => {
					return {
						name: i.name,
						quantity: i.quantity
					}
				})),
				service_areas: JSON.stringify(this.state.service_areas?.filter((i: any) => i.name != '').map((i: any) => {
					return {
						name: i.name,
						price: i.price,
						type_id: i.type_id,
						limit: i.limit
					}
				}))
			});
			Globals.showSuccess("Se ha modificado el servicio correctamente");
			this.props.onClose();
		}
		else {
			if (!this.state.form.photo) {
				Globals.showError('Debe ingresar la foto del servicio');
				return;
			}

			if (!this.state.form.banner) {
				Globals.showError('Debe ingresar la foto del banner');
				return;
			}

			await ServiceService.admin.create({
				...this.state.form,
				hasFile: true,
				// @ts-ignore,
				photo: this.state.form.photo?.value || '',
				// @ts-ignore,
				banner: this.state.form.banner?.value || '',
				// @ts-ignore,
				secondary_photo: this.state.form.secondary_photo?.value || '',
				journeys: JSON.stringify(this.state.journeys.map((i: any) => {
					return {
						journey_id: i.id,
						quantity: i.quantity
					}
				})),
				service_includes: JSON.stringify(this.state.service_includes?.filter((i: any) => i.name != '').map((i: any) => {
					return {
						name: i.name,
						quantity: i.quantity
					}
				})),
				service_areas: JSON.stringify(this.state.service_areas?.filter((i: any) => i.name != '').map((i: any) => {
					return {
						name: i.name,
						price: i.price,
						type_id: i.type_id,
						limit: i.limit
					}
				}))
			});
			Globals.showSuccess("Se ha creado el servicio correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="create-service">
				<TitleModalRight
					title={ this.props.title }
					onClose={ this.props.onClose }
				/>
				<form onSubmit={ this.submit } className="container-scroll-modal-right">
					<div className="row col-12">
						<div className="col-md-6 text-center">
							<PaperClip
								className="paperclip-image"
								value={ this.state.form.photo }
								onChange={ (e: any) => {
									this.setState({
										form: {
											...this.state.form,
											photo: e.target
										}
									})
								} }>
								{/*
								// @ts-ignore */}
								<img className={ `selected-image ${ (this.state.form.photo || this.props.item?.photo) ? '' : 'inactive' }` } src={ this.state.form.photo?.dataURL || (this.props.item?.photo ? (Constants.BASE_STORAGE + this.props.item?.photo) : WhiteImage) } />
							</PaperClip>
							<p className="paperclip-title">Icono</p>
						</div>
						<div className="col-md-6 text-center">
							<PaperClip
								className="paperclip-image"
								value={ this.state.form.banner }
								onChange={ (e: any) => {
									this.setState({
										form: {
											...this.state.form,
											banner: e.target
										}
									})
								} }>
								{/*
								// @ts-ignore */}
								<img className={ `selected-image ${ (this.state.form.banner || this.props.item?.banner) ? '' : 'inactive' }` } src={ this.state.form.banner?.dataURL || (this.props.item?.banner ? (Constants.BASE_STORAGE + this.props.item?.banner) : WhiteImage) } />
							</PaperClip>
							<p className="paperclip-title">Banner</p>
						</div>
					</div>
					<div className="col-12">
						<Input
							color="white"
							value={ this.state.form.name }
							name="name" 
							placeholder="Nombre"
							onChange={ this.change } />
					</div>
					<div className="row row-journeys">
						<div className="col-12">
							<p className="type-service-title">Precios</p>
						</div>
						<div className="col-md-6">
							<Input
								type="decimal"
								color="white"
								name="price"
								value={ this.state.form.price }
								placeholder="Precio (Detal)"
								onChange={ (e: any) => {
									this.change(e);
								} } />
						</div>
						<div className="col-md-6">
							<Input
								type="decimal"
								color="white"
								name="price_corporate"
								value={ this.state.form.price_corporate }
								placeholder="Precio (Mayor)"
								onChange={ (e: any) => {
									this.change(e);
								} } />
						</div>
					</div>
					
					<div className="row row-journeys">
						<div className="col-12">
							<p className="type-service-title">Orden</p>
						</div>
						<div className="col-md-12">
							<Input
								type="number"
								color="white"
								name="order"
								value={ this.state.form.order }
								placeholder="Orden (en el que se mostrará el servicio)"
								onChange={ (e: any) => {
									this.change(e);
								} } />
						</div>
					</div>

					<div className="row row-journeys">
						<div className="col-12">
							<p className="type-service-title">El servicio incluye (Opcional):</p>
						</div>
						{
							this.state.service_includes.length > 0 && (
								<>
									<div className="col-5">
										<p className="title-blue-journeys">Nombre</p>
									</div>
									<div className="col-5">
										<p className="title-blue-journeys">Cantidad</p>
									</div>
								</>
							)
						}
						{
							this.state.service_includes.map((i: any, index: number) => {
								return (
									<React.Fragment>
										<div className="col-5">
											<Input
												color="white"
												value={ i.name }
												placeholder="Nombre"
												onChange={ (e: any) => {
													let service_includes: any = [...this.state.service_includes];
													service_includes[index].name = e.target.value;
													this.setState({
														service_includes
													});
												} } />
										</div>
										<div className="col-5">
											<Input
												type="decimal"
												color="white"
												value={ i.quantity }
												placeholder="Cantidad (Opcional)"
												onChange={ (e: any) => {
													let service_includes: any = [...this.state.service_includes];
													service_includes[index].quantity = e.target.value;
													this.setState({
														service_includes
													});
												} } />
										</div>
										<div className="col-2">
											<button className="btn-remove" type="button" onClick={ () => {
												let service_includes: any = [...this.state.service_includes];
												service_includes.splice(index,1);
												this.setState({
													service_includes
												});	
											} }>
												<img src={ CloseIcon } />
											</button>
										</div>
									</React.Fragment>
								)
							})
						}
						<div className="col-12 text-right">
							<button type="button" className="btn-add" onClick={ () => {
								let service_includes: any = [...this.state.service_includes];
								service_includes.push({
									name: '',
									quantity: ''
								});
								this.setState({
									service_includes
								});	
							} }>
								Agregar
							</button>
						</div>
					</div>
					<p className="title-area">Áreas (A la carta):</p>
					<div className="row row-areas">
						{
							this.state.service_areas.filter((i: any) => i.type_id == null).length > 0 && (
								<>
									<div className="col-10">
										<div className="row">
											<div className="col-4" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
												<p className="title-blue-journeys">Nombre</p>
											</div>
											<div className="col-4" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
												<p className="title-blue-journeys">Precio</p>
											</div>
											<div className="col-4" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
												<p className="title-blue-journeys">Limite</p>
											</div>
										</div>
									</div>
								</>
							)
						}
						{
							this.state.service_areas.map((i: any, index: number) => {
								if (i.type_id == null)
									return (
										<React.Fragment>
											<div className="col-10">
												<div className="row">
													<div className="col-4" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
														<Input
															color="white"
															value={ i.name }
															placeholder="Nombre"
															onChange={ (e: any) => {
																let service_areas: any = [...this.state.service_areas];
																service_areas[index].name = e.target.value;
																this.setState({
																	service_areas
																});
															} } />
													</div>
													<div className="col-4" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
														<Input
															type="decimal"
															color="white"
															value={ i.price }
															placeholder="Precio"
															onChange={ (e: any) => {
																let service_areas: any = [...this.state.service_areas];
																service_areas[index].price = e.target.value;
																this.setState({
																	service_areas
																});
															} } />
													</div>
													<div className="col-4" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
														<Input
															type="number"
															color="white"
															value={ i.limit }
															placeholder="Limite (Opcional)"
															onChange={ (e: any) => {
																let service_areas: any = [...this.state.service_areas];
																service_areas[index].limit = e.target.value;
																this.setState({
																	service_areas
																});
															} } />
													</div>
												</div>
											</div>
											<div className="col-2" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
												<button className="btn-remove" type="button" onClick={ () => {
													let service_areas: any = [...this.state.service_areas];
													service_areas.splice(index,1);
													this.setState({
														service_areas
													});	
												} }>
													<img src={ CloseIcon } />
												</button>
											</div>
										</React.Fragment>
									)
							})
						}
						<div className="col-12 text-right">
							<button type="button" className="btn-add" onClick={ () => {
								let service_areas: any = [...this.state.service_areas];
								service_areas.push({
									name: '',
									price: '',
									type_id: null,
									limit: null
								});
								this.setState({
									service_areas
								});	
							} }>
								Agregar
							</button>
						</div>
					</div>
					{
						this.props.types.filter((i: any) => !Globals.isQuoteTypeBase(i.id)).map((type: any) => {
							return (
								<>
									<p className="title-area">{ type?.name }:</p>
									<div className="row row-areas">
										{
											this.state.service_areas.filter((i: any) => i.type_id == type?.id).length > 0 && (
												<>
													<div className="col-10">
														<div className="row">
															<div className="col-4" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
																<p className="title-blue-journeys">Nombre</p>
															</div>
															<div className="col-4" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
																<p className="title-blue-journeys">Precio</p>
															</div>
															<div className="col-4" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
																<p className="title-blue-journeys">Limite</p>
															</div>
														</div>
													</div>
												</>
											)
										}
										{
											this.state.service_areas.map((i: any, index: number) => {
												if (i.type_id == type?.id)
													return (
														<React.Fragment>
															<div className="col-10">
																<div className="row">
																	<div className="col-4" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
																		<Input
																			color="white"
																			value={ i.name }
																			placeholder="Nombre"
																			onChange={ (e: any) => {
																				let service_areas: any = [...this.state.service_areas];
																				service_areas[index].name = e.target.value;
																				this.setState({
																					service_areas
																				});
																			} } />
																	</div>
																	<div className="col-4" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
																		<Input
																			type="decimal"
																			color="white"
																			value={ i.price }
																			placeholder="Precio"
																			onChange={ (e: any) => {
																				let service_areas: any = [...this.state.service_areas];
																				service_areas[index].price = e.target.value;
																				this.setState({
																					service_areas
																				});
																			} } />
																	</div>
																	<div className="col-4" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
																		<Input
																			type="number"
																			color="white"
																			value={ i.limit }
																			placeholder="Limite (Opcional)"
																			onChange={ (e: any) => {
																				let service_areas: any = [...this.state.service_areas];
																				service_areas[index].limit = e.target.value;
																				this.setState({
																					service_areas
																				});
																			} } />
																	</div>
																</div>
															</div>
															<div className="col-2" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
																<button className="btn-remove" type="button" onClick={ () => {
																	let service_areas: any = [...this.state.service_areas];
																	service_areas.splice(index,1);
																	this.setState({
																		service_areas
																	});	
																} }>
																	<img src={ CloseIcon } />
																</button>
															</div>
														</React.Fragment>
													)
											})
										}
										<div className="col-12 text-right">
											<button type="button" className="btn-add" onClick={ () => {
												let service_areas: any = [...this.state.service_areas];
												service_areas.push({
													name: '',
													price: '',
													type_id: type?.id,
													limit: null
												});
												this.setState({
													service_areas
												});	
											} }>
												Agregar
											</button>
										</div>
									</div>
								</>
							)
						})
					}
					<div className="col-12">
						<p className="title-blue-journeys">Descripción del Servicio</p>
						<ReactQuill theme="snow" value={ this.state.form.description } onChange={(event) => {
							this.setState({
								form: {
									...this.state.form,
									description: event
								}
							});
						}} />
					</div>
					{/*<div className="col-12" style={{ paddingTop: '15px' }}>
						<Input
							color="white"
							value={ this.state.form.recommendation }
							name="recommendation" 
							label="Recomendaciones (Opcional)"
							onChange={ this.change } />
					</div>
					<div className="col-12">
						<Input
							color="white"
							value={ this.state.form.tasks }
							name="tasks" 
							label="Tareas (Opcional)"
							onChange={ this.change } />
					</div>*/}
					<div className="col-12 text-center">
						<p className="title-blue-journeys" style={{
							marginTop: '30px'
						}}>Foto Secundaria (Opcional)</p>
						<PaperClip
							className="paperclip-image"
							value={ this.state.form.secondary_photo }
							onChange={ (e: any) => {
								this.setState({
									form: {
										...this.state.form,
										secondary_photo: e.target
									}
								})
							} }>
							{/*
							// @ts-ignore */}
							<img className={ `selected-image ${ (this.state.form.secondary_photo || this.props.item?.secondary_photo) ? '' : 'inactive' }` } src={ this.state.form.secondary_photo?.dataURL || (this.props.item?.secondary_photo ? (Constants.BASE_STORAGE + this.props.item?.secondary_photo) : WhiteImage) } />
						</PaperClip>
					</div>
					{/*<div className="items-types" style={{ width: '90%', margin: '0 auto', marginTop: '20px' }}>
						<div className="item-type" onClick={ () => {
							this.setState({
								form: {
									...this.state.form,
									include_marquee: this.state.form.include_marquee == Constants.INCLUDE_MARQUEE.YES ? Constants.INCLUDE_MARQUEE.NO : Constants.INCLUDE_MARQUEE.YES
								}
							});
						} }>
							<div className={ `circle ${ this.state.form.include_marquee == Constants.INCLUDE_MARQUEE.YES ? 'active' : '' }` } />
							<p>Incluir marquesina</p>
						</div>
					</div>*/}
					<div className="col-12 text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default CreateService;